import React from 'react';

import { Helmet } from 'react-helmet';

import { Container } from '@mui/material';

import GHAPriceReports from './GHAPriceReports';

function GHAPriceCompetitivenessContainer() {
  return (
    <Container>
      <Helmet>
        <title>GHA Pricing Data</title>
      </Helmet>
      <GHAPriceReports />
    </Container>
  );
}

export default GHAPriceCompetitivenessContainer;
